import React, { useEffect, useMemo, useState } from 'react';
import { InspectionImageType } from '@/enums/InspectionImage.enum';
import { FileDetails, Image } from '@/types/Image.type';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { Images2 } from '@/features/components/images-2/Images2.tsx';
import { useImageCategories } from '@/hooks/masterData';
import { filterImageCategoriesByTemplate } from '@/utils/image-categories.util';

export const InspectionImagesV2: React.FC<DynamicComponentProps> = ({
  inspection,
  inspectionImageHandlers,
}: DynamicComponentProps) => {
  const { imageCategories } = useImageCategories();
  const templateImageCategories = useMemo(
    () => filterImageCategoriesByTemplate(imageCategories, inspection?.template?.id),
    [imageCategories, inspection?.template?.id]
  );
  const defaultLabelType =
    templateImageCategories.find((category) => category.isDefault)?.imageCategoryName ??
    templateImageCategories[0]?.imageCategoryName ??
    '';
  const [selectedLabelType, setSelectedLabelType] = useState<string>(defaultLabelType);

  useEffect(() => {
    if (inspectionImageHandlers?.loadImages) {
      inspectionImageHandlers.loadImages();
    }
  }, []);

  useEffect(() => {
    setSelectedLabelType((current) => {
      const isCurrentValid = templateImageCategories.some(
        (category) => category.imageCategoryName === current
      );
      return isCurrentValid ? current : defaultLabelType;
    });
  }, [templateImageCategories, defaultLabelType]);

  async function onAdd(file: FileDetails): Promise<void> {
    if (inspectionImageHandlers?.onAdd) {
      const newImage = { type: InspectionImageType.FULL_PRODUCT, isNew: true, ...file };
      inspectionImageHandlers.onAdd(newImage, InspectionImageType.FULL_PRODUCT);
    }
  }

  async function onRemove(img: Image): Promise<void> {
    if (inspectionImageHandlers?.onDelete) {
      inspectionImageHandlers.onDelete(img, InspectionImageType.FULL_PRODUCT);
    }
  }
  return (
    <Images2
      selectedLabelType={selectedLabelType}
      type={InspectionImageType.FULL_PRODUCT}
      setSelectedLabelType={setSelectedLabelType}
      inspectionId={inspection?.id || ''}
      images={inspection.fpImages || []}
      onAdd={onAdd}
      onRemove={onRemove}
      imageTypes={templateImageCategories.map((category) => ({
        name: category.imageCategoryName,
        order: category.displayOrder,
      }))}
      requirePortraitOrientation
    />
  );
};
